<div class="type-form-conf-group">
  <div class="group-head">
    <span class="group-handle icon-drag-handle"></span>
    <op-group-edit-in-place [name]="group.name"
      (onValueChange)="rename($event)"
      class="group-name" />
      <primer-icon-button
        icon="x"
        scheme="invisible"
        size="small"
        class="delete-group"
        tooltip-direction="w"
        [label]="text.delete_group"
        (clicked)="deleteGroup.emit()"
      />
  </div>
  <div class="attributes" dragula="attributes" [(dragulaModel)]="group.attributes">
    @for (attribute of group.attributes; track attribute) {
      <div
        class="type-form-conf-attribute"
        [attr.data-key]="attribute.key">
        <span class="attribute-handle icon-drag-handle"></span>
        <span class="attribute-name">
          {{ attribute.translation }}
          @if (attribute.is_cf) {
            <span class="attribute-cf-label"
              [textContent]="text.custom_field">
            </span>
          }
        </span>
        <primer-icon-button
          icon="x"
          scheme="invisible"
          size="small"
          class="delete-attribute"
          tooltip-direction="w"
          [label]="text.remove_attribute"
          (clicked)="removeFromGroup(attribute)"
        />
      </div>
    }
  </div>
</div> <!-- END attribute group -->
